import React, { useContext, useState } from "react";
import { useHistory } from 'react-router-dom';
import { useFormik } from "formik";
import { loginSchema } from "../login.schema";
import LoginPrestadoresView from "./LoginPrestadoresView";
import { UseLoginPrestador, UseLoginWithGoogle } from '../../../services/Login';

import UserContext from "../../../Context/UserContext";

const LoginPrestadores = () => {
    /* TODO: Cambiar el contexto por prestador. Lo envia Alva. */
    const { setUser } = useContext(UserContext)

    const history = useHistory();

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState({
        state: false,
        message: ""
    });

    const responseGoogle = async (response) => {

        const login_valido = await UseLoginWithGoogle(response.profileObj.email)

        /* TODO: Validar que el prestador este aprobado por admin. */
        if (login_valido.success) {
            setUser(login_valido.validEmail);
            history.push("/")
        } else {
            setError({
                state: true,
                message: "Usuario no valido."
            })
        }

    }

    const validacion_de_prestador = async (email, password) => UseLoginPrestador(email, password);

    const formik = useFormik({

        initialValues: {
            email: "",
            password: "",
        },

        validationSchema: loginSchema,

        onSubmit: async () => {

            const prestador_valido = await validacion_de_prestador(
                formik.values.email,
                formik.values.password
            );


            /* TODO: Validar que el prestador este aprobado por admin. */
            if (prestador_valido.token) {

                localStorage.setItem("token", prestador_valido.token);
                setUser(prestador_valido.payload.worker);
                setLoading(true)

                setError({ state: false })

                setTimeout(() => {

                    setError({ state: false })

                    formik.handleReset();

                    history.push(`/`);

                    /*  getInfo(setUser, history); */
                }, 2000);


            } else {

                setLoading(true)

                setTimeout(() => {

                    formik.handleReset();

                    setError({
                        state: true,
                        message: "Usuario y/o contraseña incorrecta."
                    });

                    setLoading(false)
                }, 2000);
            }
        }
    })

    return (
        <LoginPrestadoresView
            formik={formik}
            loading={loading}
            error={error}
            responseGoogle={responseGoogle}
        />
    )
}

export default LoginPrestadores;
